import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { Logo } from "@/components/Logo";
import { pad2, api } from "@/lib/api";

const TABLES = Array.from({ length: 15 }, (_, i) => i + 1);

const Sticker = ({ base, floor, table, outlet }) => (
  <div className="sticker bg-paper border-2 border-forest rounded-2xl p-4 flex flex-col items-center text-center break-inside-avoid" data-testid={`qr-sticker-${floor}-${table}`}>
    <Logo small />
    <div className="mt-3 bg-white p-2 rounded-lg border border-sage-200">
      <QRCodeSVG value={`${base}/?gerai=${outlet?.code || ""}&lantai=${floor}&meja=${table}`} size={132} fgColor="#173A60" level="M" />
    </div>
    <div className="font-serif font-bold text-2xl mt-3 text-ink">Meja {pad2(table)}</div>
    <div className="text-xs font-semibold tracking-[0.15em] text-forest">LANTAI {floor}{outlet ? ` · ${outlet.name.toUpperCase()}` : ""}</div>
    <div className="text-[11px] text-muted2 mt-2">Scan untuk pesan · bayar QRIS / transfer</div>
  </div>
);

export const QrStickers = () => {
  const [base, setBase] = useState(window.location.origin);
  const [floor, setFloor] = useState("all");
  const [outlets, setOutlets] = useState([]);
  const [oc, setOc] = useState("");
  useEffect(() => {
    api.get("/admin/outlets").then((r) => { const act = r.data.filter((o) => o.active); setOutlets(act); setOc(act[0]?.code || ""); }).catch(() => {});
  }, []);
  const outlet = outlets.find((o) => o.code === oc);
  const floors = floor === "all" ? [1, 2] : [Number(floor)];
  const clean = base.trim().replace(/\/+$/, "");

  return (
    <div>
      <div className="no-print flex flex-wrap items-end gap-3 card-paper p-5">
        <label className="text-sm flex-1 min-w-[240px]">
          <span className="text-muted2">Alamat website di QR</span>
          <input value={base} onChange={(e) => setBase(e.target.value)} className="w-full mt-1 px-3 py-2.5 rounded-lg border border-sage-200 bg-white/70 text-sm" data-testid="qr-base-url-input" />
        </label>
        <select value={oc} onChange={(e) => setOc(e.target.value)} className="px-3 py-2.5 rounded-lg border border-sage-200 bg-white/70 text-sm" data-testid="qr-outlet-select">
          {outlets.map((o) => <option key={o.code} value={o.code}>Gerai {o.name} ({o.code})</option>)}
        </select>
        <div className="flex gap-2">
          {[["all", "Semua"], ["1", "Lantai 1"], ["2", "Lantai 2"]].map(([v, l]) => (
            <button key={v} onClick={() => setFloor(v)} data-testid={`qr-floor-filter-${v}`}
              className={`pill ${floor === v ? "bg-forest text-paper" : "bg-sage-100 hover:bg-sage-200"}`}>{l}</button>
          ))}
        </div>
        <button onClick={() => window.print()} className="btn-forest px-5 py-2.5 flex items-center gap-2 text-sm" data-testid="qr-print-button"><Printer className="w-4 h-4" /> Cetak stiker</button>
      </div>
      <p className="no-print text-xs text-muted2 mt-3">Tips: pakai alamat domain asli (mis. https://uplinkcoffee.com) sebelum mencetak. Ukuran tiap stiker ±6 cm.</p>
      <div className="print-area grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-5">
        {floors.flatMap((f) => TABLES.map((t) => <Sticker key={`${f}-${t}`} base={clean} floor={f} table={t} outlet={outlet} />))}
      </div>
    </div>
  );
};
